// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__xuKtX","label":"CategoryService_label__1Berv","location":"CategoryService_location__1-Sx3"};